import { useWindowVirtualizer } from '@tanstack/react-virtual'

import { CartAndOrderCreationMobile } from '@/components/Cart/CartAndOrderCreationMobileCart/CartAndOrderCreationMobileCart'
import type { CartProductInterface } from '@/types'
import getProductKey from '@/utils/products/getProductKey'

import cn from './VirtualizedCartList.module.scss'

interface VirtualizedMobileCartProps {
  products: CartProductInterface[]
  deleteById?: (itemId: string) => void
  highlightedProductId?: string | null
  updateProducts?: (newProducts: CartProductInterface[]) => void
  productsChecked: CartProductInterface[]
  onCheck: (checked: boolean, product: CartProductInterface) => void
  allProducts: CartProductInterface[]
  mode?: 'cart' | 'order'
}

export const VirtualizedMobileCart = ({
  products,
  deleteById,
  highlightedProductId,
  updateProducts,
  productsChecked,
  onCheck,
  allProducts,
  mode = 'cart',
}: VirtualizedMobileCartProps) => {
  const rowVirtualizer = useWindowVirtualizer({
    count: products.length,
    estimateSize: (index) => {
      const product = products[index]
      const baseHeight = 340
      const textLength = product.nomenclatureDto.description?.length ?? 0
      const lines = Math.ceil(textLength / 30)
      const lineHeight = 20
      return baseHeight + lines * lineHeight
    },
    overscan: 5,
  })

  const virtualItems = rowVirtualizer.getVirtualItems()
  const totalSize = rowVirtualizer.getTotalSize()

  return (
    <div
      className={cn.virtualList}
      style={{ '--virtual-total-size': `${totalSize}px` }}
    >
      {virtualItems.map((virtualRow) => {
        const product = products[virtualRow.index]
        const checked = productsChecked.some(
          (p) => getProductKey(p) === getProductKey(product)
        )

        return (
          <div
            key={getProductKey(product)}
            className={cn.virtualItem}
            style={{ '--virtual-row-start': `${virtualRow.start}px` }}
          >
            <CartAndOrderCreationMobile
              product={product}
              deleteById={deleteById}
              highlightedProductId={highlightedProductId}
              updateProducts={updateProducts}
              checked={checked}
              allProducts={allProducts}
              index={virtualRow.index}
              mode={mode}
              onCheck={onCheck}
            />
          </div>
        )
      })}
    </div>
  )
}
